import {
  GENERATE_TEXT_TO_IMAGE,
} from '../constants/actionTypes';

const INITIAL_STATE = { imageUrl: [], errors: null };

export default function textToImageGeneration(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GENERATE_TEXT_TO_IMAGE:
      console.log("IMAGE GENERATION REDUCER FILE",action.payload)
      return { ...state, imageUrl: [ ...state.imageUrl, action.payload ], errors: null };
    default:
      return state;
  }
}
